const sowSlides = Array.from({ length: 6 }, (_, index) => {
  const number = String(index + 1).padStart(2, '0')
  return `/sow/sow-${number}.webp`
})

export function SowPage() {
  return (
    <div className="page-stack sow-page">
      <header className="page-heading">
        <div>
          <span className="eyebrow">ESS STATEMENT OF WORK</span>
          <h1>SOW</h1>
          <p>ESS 工作職責、服務範圍與合作方式，共 6 張說明。</p>
        </div>
      </header>

      <section className="sow-gallery" aria-label="SOW 圖片">
        {sowSlides.map((src, index) => (
          <figure key={src} className="sow-slide">
            <a href={src} target="_blank" rel="noreferrer" title={`開啟 SOW 第 ${index + 1} 張原圖`}>
              <img
                src={src}
                alt={`SOW 第 ${index + 1} 張`}
                width="1672"
                height="941"
                loading={index === 0 ? 'eager' : 'lazy'}
                fetchPriority={index === 0 ? 'high' : 'auto'}
                decoding="async"
              />
            </a>
          </figure>
        ))}
      </section>
    </div>
  )
}
